import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#dd7373',
            secondary: '#ffffff',
            accent: '#84dcc6',
          },
        },
      },
});
